import { singleton } from '~/decorators/dependency-container'
import { Extra } from '~/models/classified/types'
import { CLASSIFIED_EXTRA_ABBREVIATIONS } from '~/constants/classified/view/extra'

@singleton()
export default class ClassifiedExtraViewService {
  formatExtraValue({ value }: Extra): string {
    const v = value.toLocaleLowerCase()

    for (const abbr of CLASSIFIED_EXTRA_ABBREVIATIONS) {
      const idx = v.indexOf(abbr)

      if (idx === -1) {
        continue
      }

      const start = idx
      const end = idx + abbr.length

      const allowedAdjacentChars = ' ,.-/!?()[]{}'
      if (
        (end < v.length && !allowedAdjacentChars.includes(v[end])) ||
        (start - 1 >= 0 && !allowedAdjacentChars.includes(v[start - 1]))
      ) {
        return value
      }
      return (
        value.substring(0, start) +
        v.substring(start, end).toLocaleUpperCase() +
        value.substring(end, value.length)
      )
    }

    return value
  }
}
